import React from 'react';
import UIStrings from '@/Utils/UIStrings';
import ActionConfirmationDialog from './Components/ActionConfirmationDialog';
import DialogCardContainer from './Components/DialogCardContainer';
import DialogHeader from './Components/DialogHeader';
import HireActions from './Components/Hire/HireActions';
import HireDialogBody from './Components/Hire/HireDialogBody';
import HireDialogHeader from './Components/Hire/HireDialogHeader';
import { DialogEnum } from './Context/ActionDialogContext';

function HireDialog() {
    return (
        <ActionConfirmationDialog
            className="max-w-lg"
            dialogType={DialogEnum.Hire}
            header={<DialogHeader title={UIStrings.Hire} badgeClassName="bg-percentile-high" />}
            body={
                <DialogCardContainer
                    dialogTitle={<HireDialogHeader />}
                    dialogBody={<HireDialogBody />}
                    className="my-4 h-fit bg-white p-0"
                />
            }
            actions={<HireActions />}
        />
    );
}

export default HireDialog;
